import { END_POINT } from "constants/apiConstant";
import { apiGet, apiPost } from "../utils/apiUtils";

const { TME_ORDER_EMAIL, TME_SEND_ORDER_EMAIL } = END_POINT;

// Fetch the TME order email configured for the company (to pre-fill the draft).
export const getTmeOrderEmail = async () => {
  return await apiGet(TME_ORDER_EMAIL);
};

// Send the TME order email with the generated Excel attached.
export const sendTmeOrderEmail = async (payload) => {
  return await apiPost(TME_SEND_ORDER_EMAIL, payload);
};
